import {useState} from 'react'
import SortingGradingForm from './SortingGradingForm';
import SortingGradingListview from './SortingGradingListview';

const SortingGarding = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
    return (
      <>
        {fromIsShown ? (
          <SortingGradingForm addForm={setFromIsShown} update={upData}  sId={serviceId}/>
        ) : (
          <SortingGradingListview addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
        )}
      </>
  )
}

export default SortingGarding